import React, { createContext, useContext, useState } from "react";

import variables from "../environment/environment.variables";

type EnvironmentContextState = {
  backendBaseUrl?: string;
  graphqlBaseUrl?: string;
};
const EnvironmentContext: React.Context<EnvironmentContextState> =
  createContext({});

// -- React Providers -- //
function EnvironmentProvider({ children }) {
  const [state] = useState<EnvironmentContextState>({
    backendBaseUrl:
      variables.graphqlBaseUrl.replace("/graphql", "") ??
      "http://localhost:4000",
    graphqlBaseUrl: variables.graphqlBaseUrl ?? "http://localhost:4000/graphql",
  });

  return (
    <EnvironmentContext.Provider value={state}>
      {children}
    </EnvironmentContext.Provider>
  );
}

// -- Context Hooks -- //
function useEnvironmentState() {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error(
      "useEnvironmentState can only be used within a EnvironmentProvider"
    );
  }

  return context;
}

export { EnvironmentProvider, useEnvironmentState };
